import { type ReactNode } from 'react';
import cx from 'classnames';
import { RiskIndicatorBar } from '@/components';
import { RiskScoreLevelEnum } from '@/api';
import { getRiskTypeByLevel } from '@/helpers';

import styles from './RiskBadgeBar.module.sass';

interface RiskBadgeBarProps {
  level: RiskScoreLevelEnum;
  note?: ReactNode;
  className?: string;
}

const RiskBadgeBar = ({ level, note, className }: RiskBadgeBarProps) => {
  const riskType = getRiskTypeByLevel(level);

  const riskTitle: Record<string, string> = {
    trusted: 'Low',
    suspicious: 'Medium',
    danger: 'High',
    unknown: 'N/D',
  };

  const classes = cx(styles.risk, styles[`risk--${level}`], className);

  return (
    <div className={classes}>
      <div className={styles.inner}>
        <RiskIndicatorBar risk={level} className={styles.bar} />
        <div className={styles.title}>{riskTitle[riskType]}</div>
      </div>
      {note && <div className={styles.note}>{note}</div>}
    </div>
  );
};

export default RiskBadgeBar;
